<template>
  <div class="bookBox wow animate__slideInUp">
    <ul class="bookUl">
      <li
        :key="idx"
        v-for="(item, idx) in bookList"
      >
        <el-image
          class="bookFigure"
          :src="item.PicUrl"
          fit="cover"
        ></el-image>
        <a class="bookBody" :href="item.Url" target="_blank">
          <span>{{ moment(item.PubDate).format("YYYY-MM-DD") }}</span>
          <h3>
            <span>{{ item.Title }}</span>
          </h3>
          <p>{{ item.Summary }}</p>

          <div><span class="bigMore greyBtn">下载</span></div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  data() {
    return {
      moment: this.$moment,
    };
  },
  props: ["bookList"],

};
</script>

<style lang="scss">
.bookUl {
  margin: 50px 0 0 30px;
  border-bottom: 1px solid #ddd;
  min-height: 300px;

  li {
    display: flex;
    padding: 20px;
    border-top: 1px solid #ddd;
    overflow: hidden;
    &:hover {
      background: #f7f7f7;

      .bookLine {
        animation: fadeOutRightBig;
        animation-duration: 0.1s;
      }
      h3 {
        // color: #d71820;
      }
      .bookBtn {
        background: #d71820 !important;
        color: #fff;
      }
    }
    align-items: flex-start;
    .bookFigure {
      width: 165px;
      margin-right: 1em;
      height: 235px;
      border: 1px solid #ddd;
    }
    .bookBody {
      flex: 1;
      display: block;
      text-align: left;
      padding-top: 20px;
      p {
        padding: 0 0 20px 0;
        min-height: 50px;
      }
      h3,
      .bookBottom {
        display: flex;
        justify-content: space-between;
      }
      h3 {
        font-size: 20px;
        padding: 10px 0;
      }
      .bookLine {
        border-left: 1px solid #ddd;
        padding-left: 10px;
        overflow: hidden;
      }
      .bookBtn {
        line-height: 30px;
        padding: 0 30px;
        font-size: 12px;
        border: 1px solid #ddd;
        background: #fff;
        display: inline-block;
      }
    }
  }
}
</style>